module.exports = __webpack_public_path__ + "img/united-kingdom.db68882c.svg";